class SideDrawerToggle extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", function (evt) {
      evt.preventDefault();
      //get drawer element by ID from click event target data attribute
      let drawer = document.getElementById(this.getAttribute("data-drawer"));
      //dispatch event to trigger drawer state
      if (drawer) {
        drawer.dispatchEvent(new Event("drawer-toggle"));
      }
    });
  }
}

customElements.define("side-drawer-toggle", SideDrawerToggle);